import React from 'react';
import { Button, Empty, Flex, Input, Space, Tag, Typography } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';

const { Text } = Typography;

const ItemMetadataManager = ({
  itemMetadata,
  onMetadataAdd,
  onMetadataChange,
  onMetadataDelete,
  selectedProduct,
}) => {
  return (
    <div style={{ marginTop: 16 }}>
      <Flex justify="space-between" align="center" style={{ marginBottom: 8 }}>
        <Text strong>Metadata</Text>
        <Button
          type="dashed"
          size="small"
          icon={<PlusOutlined />}
          onClick={onMetadataAdd}
        >
          Add
        </Button>
      </Flex>

      {itemMetadata.length === 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <Text type="secondary" style={{ fontSize: 12 }}>
              {selectedProduct
                ? 'No metadata for this product.'
                : 'Select a product to load metadata, or add custom fields.'}
            </Text>
          }
          style={{ margin: '8px 0' }}
        />
      ) : (
        <Space direction="vertical" size={8} style={{ width: '100%' }}>
          {itemMetadata.map((metadata, metadataIndex) => (
            <Flex key={metadataIndex} gap={8} align="center" wrap="wrap">
              <Input
                size="small"
                placeholder="Key"
                value={metadata.key_name}
                onChange={(e) =>
                  onMetadataChange(metadataIndex, 'key_name', e.target.value)
                }
                style={{ flex: '1 1 140px', minWidth: 120 }}
                suffix={
                  metadata.is_mandatory ? (
                    <Tag color="error" style={{ marginInlineEnd: 0 }}>
                      required
                    </Tag>
                  ) : null
                }
              />
              <Input
                size="small"
                status={
                  metadata.is_mandatory && !metadata.value ? 'error' : undefined
                }
                placeholder={metadata.is_mandatory ? 'Required value' : 'Value'}
                value={metadata.value}
                onChange={(e) =>
                  onMetadataChange(metadataIndex, 'value', e.target.value)
                }
                style={{ flex: '1 1 160px', minWidth: 140 }}
                required={metadata.is_mandatory}
              />
              <Button
                type="text"
                danger
                size="small"
                icon={<DeleteOutlined />}
                onClick={() => onMetadataDelete(metadataIndex)}
                aria-label="Delete metadata"
              />
            </Flex>
          ))}
        </Space>
      )}
    </div>
  );
};

export default ItemMetadataManager;
